import LocalStorageKeys from "./LocalStorageKeys";
import StorageItem from "./StorageItem";

export default {
    config: StorageItem(LocalStorageKeys.CONFIG),
	configuratorOutputType: StorageItem(LocalStorageKeys.CONFIGURATOR_OUTPUT_TYPE),
    configuratorType: StorageItem(LocalStorageKeys.CONFIGURATOR_TYPE),
};
